// extracted by mini-css-extract-plugin
export var emptyState = "_5k-d";
export var statCard = "_5k-c";
export var table = "_5k-0";
export var tableCell = "_5k-4";
export var tableCellClickable = "_5k-5 _5k-4";
export var tableCellDefault = "_5k-6 _5k-4";
export var tableCellEmpty = "_5k-8";
export var tableCellWithValue = "_5k-7";
export var tableContainer = "_5k-e";
export var tableHeaderWeight = "_5k-1";
export var tableHeaderZone = "_5k-2";
export var tableRowHeader = "_5k-3";
export var viewModeButton = "_5k-9";
export var viewModeButtonActive = "_5k-a _5k-9";
export var viewModeButtonInactive = "_5k-b _5k-9";